import { Component, Input } from '@angular/core';
import { SeriesLabels, SeriesLabelsContentArgs } from '@progress/kendo-angular-charts';
import { commonService } from 'src/app/services/common.service';
import { DataPointDto, DataPointGraphModel } from '../../reportingdashboard/model/data-point-graph.model';

@Component({
  selector: 'app-common-chart',
  templateUrl: './common-chart.component.html',
  styleUrl: './common-chart.component.scss'
})
export class CommonChartComponent {
  public columnAxisLabels: any = {
    rotation: { angle: 0 },
    font: '12px Arial',
    color: '#333',
    skip: 0,
    step: 1
  };
  public lineAxisLabels = {
    rotation: { angle: 0 },
    font: '12px Arial',
    color: '#333',
    skip: 0,
    step: 1
  };
  constructor(private commonService: commonService) {
  }

  isInputReceived: boolean = false;
  type = "column";
  dataSet: DataPointGraphModel[] = [];

  percentValues!: number[];
  maxValue: number = 100;
  majorUnit: number = 25;
  columnSpacing = 0.3;
  columnGap = 0.3;
  @Input() set setGraphType(type: any) {
    if (type) {
      this.type = type;
    }
  }

  @Input() set setDataSet(dataSet: any[]) {
    if (dataSet.length > 0) {
      this.dataSet = dataSet;
      console.log(this.dataSet);

      // Dynamically adjust label rotation based on data length
      const totalPoints = dataSet.reduce((sum, series) => sum + (series.data?.length || 0), 0);
      if (totalPoints > 8) {
        this.columnSpacing = 0.1; // tighter spacing for many columns
        this.columnGap = 0.3;
        this.columnAxisLabels.rotation.angle = -45;
      } else if (totalPoints === 1) {
        this.columnSpacing = 0.3; // wider spacing for single column
        this.columnGap = 0.9;
        this.columnAxisLabels.rotation.angle = 0;
      } else {
        this.columnSpacing = 0.3; // default for 2–6 columns
        this.columnGap = 0.9;
        this.columnAxisLabels.rotation.angle = 0;
      }

    } else {
      this.dataSet = [];
    }
    this.isInputReceived = true;
  }

  legendVisibiltyStatus: boolean = false;
  @Input() set setLegendVisibiltyStatus(status: boolean) {
    this.legendVisibiltyStatus = status;
  }

  public seriesLabels: SeriesLabels = {
    visible: true,
    position: 'insideEnd',
    margin: 4,
    padding: 2,
    color: '#000',
    font: 'bold 12px Arial', // Default font
    background: '#00000000',
    align: 'center',
    content: (x: any) => x.value ? x.value + '%' : ''
  };

  public historicalSeriesLabels: SeriesLabels = {
    visible: true,
    margin: 0,
    padding: 0,
    color: 'black',
    background: 'white',
  };

  @Input() isAsset: boolean = false;

  columnSeriesColors: string[] = ["#43addb"];
  lineSeriesColors: string[] = ["#43addb", '#e2615d', '#7f7f7f'];

  calculateYAxisParameters() {
    // Find the maximum value in the data set 
    const maxValue = Math.max(...this.percentValues);
    // Determine a suitable maximum value for the Y-axis 
    this.maxValue = Math.ceil(maxValue / 10) * 10;
    // Rounding up to the nearest 10 
    // Calculate major unit for approximately 5 labels 
    this.majorUnit = Math.ceil(this.maxValue / 5);
  }

  valueAxisLabels = {
    format: '{0}%', // Format labels as percentages 
    visible: true
  };

}

